import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['destination']

  sync (event) {
    if (this.destinationTargets.includes(event.target)) return

    this.destinationTargets.forEach((destination) => {
      destination.value = event.target.value
    })
  }

  commit (event) {
    if (this.destinationTargets.includes(event.target)) return

    this.destinationTargets.forEach((destination) => {
      destination.value = event.target.value
      destination.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }
}
